import { render, staticRenderFns } from "./BillingCreditUsage.vue?vue&type=template&id=0ba82b20"
import script from "./BillingCreditUsage.vue?vue&type=script&lang=js"
export * from "./BillingCreditUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports